import { render, staticRenderFns } from "./AncestrylineDataTableFieldDisplay.vue?vue&type=template&id=74775d33"
import script from "./AncestrylineDataTableFieldDisplay.vue?vue&type=script&lang=js"
export * from "./AncestrylineDataTableFieldDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports